import _ from 'lodash';

export const kindFormatted = kind => _.chain(kind)
  .split('_')
  .map(_.capitalize)
  .join(' ')
  .value();

export const PRODUCT_CELL_EMPTY = '—';

export const BATCH_PRODUCT_MULTIPLE = 'Multiple';

export const formatProductCell = name => name || PRODUCT_CELL_EMPTY;

// Return Invoices has no product master row for every offer, so it falls back to the
// coverage the purchase was made on, the same way Guarantee Purchases does. Days and miles
// are emitted separately because either one can be missing on an older offer.
export const formatCoverageProduct = ({
  productName, kind, daysSelected, milesSelected,
}) => {
  if (productName) return productName;

  const coverage = [
    daysSelected == null ? null : `${daysSelected} D`,
    milesSelected == null ? null : `${milesSelected} M`,
  ]
    .filter(Boolean)
    .join(' ');
  const label = kindFormatted(kind);

  if (label && coverage) return `${label} (${coverage})`;
  return label || coverage || PRODUCT_CELL_EMPTY;
};

// An offer with no product name is unknown rather than different, so it is dropped before
// comparing: a batch of one named offer and one unnamed one reads as that one product.
export const resolveBatchProduct = flatRateOffers => {
  const names = (flatRateOffers || [])
    .map(offer => offer?.productName)
    .filter(Boolean);
  const distinct = [...new Set(names)];

  if (distinct.length === 0) return null;
  return distinct.length === 1 ? distinct[0] : BATCH_PRODUCT_MULTIPLE;
};

// `FlatRateOfferBatchType` exposes flatRateOffers as a gated_field, so a caller who is not
// entitled to the batch receives null for the whole collection — not an empty one. Every
// other gated cell on that row renders empty, and the product cell follows them: an em dash
// there would claim the product is unknown when the truth is that it is not disclosed.
// An empty array, by contrast, is a batch the caller *can* see that simply has no offers,
// which is genuinely unknown and does get the placeholder.
export const formatBatchProductCell = flatRateOffers => (
  flatRateOffers == null
    ? ''
    : formatProductCell(resolveBatchProduct(flatRateOffers))
);
